<template>
  <div class="root">
    <div class="left">
      <div class="result">
        セルフチェックの結果…
      </div>
      <div class="description">
        <span v-if="isAdhd">ADHDの症状を持っている可能性が考えられます。</span>
        <span v-else
          >あなたが、ADHDの症状を持っている可能性は「低い」です。</span
        >
      </div>
    </div>
    <div class="right">
      <img alt="logo" src="@/assets/adhd/top-explanation02.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: "DiagnosisResult",
  props: {
    isAdhd: {
      type: Boolean,
      required: true
    }
  }
};
</script>
<style scoped>
.root {
  display: flex;
  margin: 16px;
  background-color: #f0fafa;
  align-items: center;
  border-radius: 5px;
  border: 2px solid #28c8be;
}
.root .left {
  flex: 1;
  margin: 0px 16px 0px 20px;
  text-align: left;
  font-size: 16px;
  font-weight: 700;
}
.root .left .result {
  color: #28c8be;
  font-size: 15px;
  font-weight: 700;
}
.root .left .description {
  margin-top: 8px;
}
.root .right {
  width: 96px;
  margin: 20px 20px 20px 16px;
}
</style>
